import { Component, OnInit } from '@angular/core';
import {ReturnRemarkComponent} from '../../../approval-process/return-remark/return-remark.component';
import {FwdRemarkComponent} from '../../../approval-process/fwd-remark/fwd-remark.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {ApprovalModel} from '../../../shared/dto/approval.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {RemarkComponent} from '../../../approval-process/remark/remark.component';
import {UserRoleEnum} from '../../../shared/enums/user-role.enum';
import {ApprovalService} from '../../../service/approval.service';
import {ActivatedRoute} from '@angular/router';
import {ReversedReturnRequestComponent} from '../reversed-blacklist-verification-request-viewer/reversed-return-request/reversed-return-request.component';
import {WorkflowStageEnum} from '../../../shared/enums/workflow-stage.enum';
import {BlacklistApproveChecklistComponent} from '../../../blacklist-process/blacklist-approve-checklist/blacklist-approve-checklist.component';
import {WorkflowEnum} from '../../../shared/enums/workflow.enum';

@Component({
  selector: 'app-reversed-blacklist-return-request-viewer',
  templateUrl: './reversed-blacklist-return-request-viewer.component.html',
  styleUrls: ['./reversed-blacklist-return-request-viewer.component.scss']
})
export class ReversedBlacklistReturnRequestViewerComponent implements OnInit {
  appRefNo: number;
  types: string;
  userName: string;
  userRole: string;
  type: string;
  DG:string = UserRoleEnum.DG;
  SHO:string = UserRoleEnum.SHO;
  EXM:string = UserRoleEnum.EXM;
  approvalModel: ApprovalModel = new ApprovalModel();
  stage: string = WorkflowEnum.BLACKLIST_REVERSED_RETURN;

  constructor(private route: ActivatedRoute, private tokenStorageService: TokenStorageService,
              private approvalService: ApprovalService, private modalService: NgbModal) {
    this.route.paramMap.subscribe(params => {
      this.appRefNo = +this.decodeBase64(params.get('id'));
      this.types = WorkflowStageEnum.SID_DG_REV_BLK_REJ;
    });
  }

  ngOnInit() {
    this.userName=this.tokenStorageService.getUserObjectToken().username;
    this.userRole=this.tokenStorageService.getUserObjectToken().userroleCode;
  }
  decodeBase64(code: string): string {
    return atob(code);
  }

  rejectRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'Reject';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(RemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  forwardToDg() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'FWD_DG';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(FwdRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService)
  }

  returnRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReturnRemarkComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  approveRequest() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'APPROVE';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;
    this.approvalModel.stage = WorkflowEnum.BLACKLIST_REVERSED_RETURN;

    const modalRef = this.modalService.open(BlacklistApproveChecklistComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  returnBlacklist() {
    this.approvalModel.updatedUser = this.userName;
    this.approvalModel.action = 'RETURN';
    this.approvalModel.applicationNo = this.appRefNo;
    this.approvalModel.userRole = this.userRole;
    this.approvalModel.type = this.type;

    const modalRef = this.modalService.open(ReversedReturnRequestComponent,{size: 'lg'});
    let data = {
      model: this.approvalModel,
    }

    modalRef.componentInstance.fromParent = data;
    this.approvalService.setModel(this.modalService);
  }

  blacklistData() {

  }

}
